import { stringify } from "qs";
import React, {
    useRef,
    useEffect,
    useState,
    MouseEventHandler,
    useCallback,
} from "react";
import { Endpoints } from "../../../helpers/Endpoints";
import { authenticationService } from "../../../services/authentication.service";
import { FileService } from "../../../services/SubmissionService";
import * as PDFJS from "pdfjs-dist";
import pdfjsLib, {
    PDFPageView,
    TextLayerBuilder,
} from "pdfjs-dist/web/pdf_viewer";
import { render } from "react-dom";
import "pdfjs-dist/web/pdf_viewer.css";
import { TextLayerMode } from "pdfjs-dist/types/web/ui_utils";

import PubSub from "pubsub-js";

export default function PDFViewScroll({
    submissionId,
    documentId,
    filename,
}: {
    submissionId: string;
    documentId: string;
    filename: string;
}) {
    const [anchorPoint, setAnchorPoint] = useState({ x: 0, y: 0 });
    const [show, setShow] = useState(false);
    const [copyText, setCopyText] = useState("");
    const [pdfurl, setPdfurl] = useState("");

    useEffect(() => {
        PDFJS.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${PDFJS.version}/pdf.worker.js`;
        PDFJS.getDocument(pdfurl).promise.then(function (pdf) {
            const viewer = document.getElementById("pdf-viewer");
            viewer!.innerHTML = "";

            for (let i = 1; i <= pdf.numPages; i++) {
                pdf.getPage(i).then(function (page) {
                    const pageHtml = document.createElement(
                        "div"
                    ) as HTMLDivElement;
                    pageHtml.className = "page";

                    viewer!.appendChild(pageHtml);

                    const canvasWrapper = document.createElement(
                        "div"
                    ) as HTMLDivElement;
                    canvasWrapper.className = "canvaswrapper";
                    canvasWrapper.style.position = "relative";

                    pageHtml!.appendChild(canvasWrapper);

                    const canvas = document.createElement("canvas");
                    canvas.className = "canvas";

                    canvasWrapper!.appendChild(canvas);
                    const scale = 1.2;

                    const viewport = page.getViewport({ scale: scale });

                    const outputScale = window.devicePixelRatio || 1;

                    const context = canvas.getContext("2d");

                    canvas.width = Math.floor(viewport.width * outputScale);
                    canvas.height = Math.floor(viewport.height * outputScale);
                    canvas.style.width = Math.floor(viewport.width) + "px";
                    canvas.style.height = Math.floor(viewport.height) + "px";

                    const transform =
                        outputScale !== 1
                            ? [outputScale, 0, 0, outputScale, 0, 0]
                            : null;

                    const renderContext = {
                        canvasContext: context,
                        transform: transform,
                        viewport: viewport,
                    };

                    page.render(renderContext as any)
                        .promise.then(function () {
                            return page.getTextContent();
                        })
                        .then(function (textContent) {
                            page.getTextContent().then(function (textContent) {
                                const textLayer = document.createElement("div");

                                textLayer.className = "textLayer";

                                textLayer.style.lineHeight = "18px";
                                textLayer.style.padding = "150px";

                                canvasWrapper!.appendChild(textLayer);
                                //textLayer!.style.overflow = "scroll";
                                //  textLayer!.style.position = "absolute";
                                //textLayer!.style.zIndex = "-1";
                                //textLayer!.style.

                                PDFJS.renderTextLayer({
                                    textContent: textContent,
                                    container: textLayer,
                                    viewport: viewport,
                                    textDivs: [],
                                    enhanceTextSelection: true,
                                });
                            });
                        });
                });
            }
        });
    }, [pdfurl]);

    document.onclick = (ev: MouseEvent) => {
        setShow(false);
    };

    useEffect(() => {
        FileService.get({
            submissionId: submissionId,
            documentId: filename,
            source: "",
        }).then(
            (resp) => {
                resp.json().then((json) => {
                    fetch(json.url).then((resp) => {
                        const reader = new FileReader();
                        resp.blob().then((blob) => {
                            reader.readAsDataURL(blob);
                            reader.onload = function () {
                                setPdfurl(reader.result as string);
                            };
                        });
                    });
                });
            },
            (error) => {
                console.log(error);
            }
        );
    }, [submissionId, documentId]);

    const handleCopy = () => {
        const text = window.getSelection()?.toString() ?? "";
        setCopyText(text);
    };

    useEffect(() => {
        navigator.clipboard.writeText(copyText);
    }, [copyText]);

    return (
        <div>
            <div
                id="pdf-viewer-container"
                onContextMenu={(ev) => {
                    ev.preventDefault();
                    setAnchorPoint({ x: ev.pageX, y: ev.pageY });
                    setShow(true);
                }}
                style={{
                    width: "750px",
                    height: "900px",
                }}
            >
                <div
                    style={{
                        width: "750px",
                        height: "850px",
                        overflow: "auto",
                    }}
                    id="pdf-viewer"
                    className="pdf-viewer"
                ></div>
            </div>
            {show ? (
                <ul
                    id="list"
                    className="menu"
                    style={{
                        top: anchorPoint.y,
                        left: anchorPoint.x,
                    }}
                    role="tablist"
                >
                    <li>
                        <button
                            className="btn"
                            onClick={() => {
                                const text =
                                    window.getSelection()?.toString() ?? "";

                                navigator.clipboard.writeText(
                                    text.replace("\n", " ")
                                );

                                setShow(false);
                            }}
                        >
                            Copy
                        </button>
                    </li>
                    <hr className="divider" />
                    <li>
                        <button
                            className="btn"
                            onClick={() =>
                                PubSub.publish(
                                    "plaintiffOrgEvent",
                                    getSelection()
                                        ?.toString()
                                        .replace("\n", " ") ?? ""
                                )
                            }
                        >
                            Plaintiff Org
                        </button>
                    </li>

                    <li>
                        <button
                            className="btn"
                            onClick={() => {
                                PubSub.publish(
                                    "defendantOrgEvent",
                                    window
                                        .getSelection()
                                        ?.toString()
                                        .replace("\n", " ") ?? ""
                                );
                            }}
                        >
                            Defendant Org
                        </button>
                    </li>

                    <li>
                        <button
                            className="btn"
                            onClick={() =>
                                PubSub.publish(
                                    "plaintiffEvent",
                                    window
                                        .getSelection()
                                        ?.toString()
                                        .replace("\n", " ") ?? ""
                                )
                            }
                        >
                            Plaintiff Indiv
                        </button>
                    </li>

                    <li>
                        <button
                            className="btn"
                            onClick={() =>
                                PubSub.publish(
                                    "defendantEvent",
                                    window
                                        .getSelection()
                                        ?.toString()
                                        .replace("\n", " ") ?? ""
                                )
                            }
                        >
                            Defendant Indiv
                        </button>
                    </li>

                    <li>
                        <button
                            className="btn"
                            onClick={() =>
                                PubSub.publish(
                                    "addressEvent",
                                    window
                                        .getSelection()
                                        ?.toString()
                                        .replace("\n", " ") ?? ""
                                )
                            }
                        >
                            Address
                        </button>
                    </li>
                </ul>
            ) : (
                <> </>
            )}
        </div>
    );
}
